<div class="modal-header" [ngClass]="typeClass()">
    <div class="dialog-heading">
        <span class="dialog-icon" aria-hidden="true">
            <i [class]="iconClass()"></i>
        </span>

        <h5 class="modal-title">{{ title() }}</h5>
    </div>

    <button type="button" class="dialog-close" aria-label="Close" (click)="activeModal.dismiss('close')">
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
</div>

<div class="modal-body">
    <p class="dialog-message mb-0">{{ message() }}</p>

    @if (details()) {
    <pre class="dialog-details mt-2 mb-0 small">{{ details() }}</pre>
    }
</div>

<div class="modal-footer">
    @if (!dialogMode()) {
    <button type="button" class="btn btn-cancel me-1" (click)="activeModal.dismiss(false)">
        <i class="fa-solid fa-ban" aria-hidden="true"></i>
        {{ cancelText() }}
    </button>
    }

    <button type="button" class="btn btn-accept ms-auto" (click)="activeModal.close(true)">
        <i class="fa-regular fa-circle-check" aria-hidden="true"></i>
        {{ confirmText() }}
    </button>
</div>